"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AttributesLabel = _interopRequireDefault(require("./Atributes/AttributesLabel"));

var _AttributesInput = _interopRequireDefault(require("./Atributes/AttributesInput"));

var _AttributesDate = _interopRequireDefault(require("./Atributes/AttributesDate"));

var _AttributesTextarea = _interopRequireDefault(require("./Atributes/AttributesTextarea"));

var _AttributesButton = _interopRequireDefault(require("./Atributes/AttributesButton"));

var _AttributesCheckbox = _interopRequireDefault(require("./Atributes/AttributesCheckbox"));

var _AttributesRadio = _interopRequireDefault(require("./Atributes/AttributesRadio"));

var _AttributesSelect = _interopRequireDefault(require("./Atributes/AttributesSelect"));

var _AttributesAccordion = _interopRequireDefault(require("./Atributes/AttributesAccordion"));

var _AttributesImage = _interopRequireDefault(require("./Atributes/AttributesImage"));

var _AttributesContainer = _interopRequireDefault(require("./Atributes/AttributesContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accordionFilter = function accordionFilter(data) {
  return data.filter(function (res) {
    return res.type === "accordion";
  });
};

var radioFilter = function radioFilter(data) {
  return data.filter(function (res) {
    return res.type === "radio";
  });
};

var FormItemAttributes = function FormItemAttributes(_ref) {
  var objectsForm = _ref.objectsForm,
      properties = _ref.properties,
      handleItemAttribute = _ref.handleItemAttribute,
      handlePropertyChange = _ref.handlePropertyChange,
      typeForm = _ref.typeForm;

  switch (properties.type) {
    case "label":
      return /*#__PURE__*/React.createElement(_AttributesLabel.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        accordionFilter: accordionFilter
      });

    case "input":
      return /*#__PURE__*/React.createElement(_AttributesInput.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        accordionFilter: accordionFilter
      });

    case "date":
      return /*#__PURE__*/React.createElement(_AttributesDate.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        accordionFilter: accordionFilter
      });

    case "textarea":
      return /*#__PURE__*/React.createElement(_AttributesTextarea.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        accordionFilter: accordionFilter
      });

    case "button":
      return /*#__PURE__*/React.createElement(_AttributesButton.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        accordionFilter: accordionFilter
      });

    case "checkbox":
      return /*#__PURE__*/React.createElement(_AttributesCheckbox.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        accordionFilter: accordionFilter
      });

    case "radio":
      return /*#__PURE__*/React.createElement(_AttributesRadio.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        accordionFilter: accordionFilter
      });

    case "select":
      return /*#__PURE__*/React.createElement(_AttributesSelect.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        accordionFilter: accordionFilter
      });

    case "accordion":
      return /*#__PURE__*/React.createElement(_AttributesAccordion.default, {
        properties: properties,
        handlePropertyChange: handlePropertyChange,
        typeForm: typeForm
      });

    case "image":
      return /*#__PURE__*/React.createElement(_AttributesImage.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        accordionFilter: accordionFilter
      });

    case "container":
      return /*#__PURE__*/React.createElement(_AttributesContainer.default, {
        objectsForm: objectsForm,
        properties: properties,
        handleItemAttribute: handleItemAttribute,
        handlePropertyChange: handlePropertyChange,
        accordionFilter: accordionFilter
      });

    default:
      // console.log("Elemento invalido");
      return;
  }
};

var _default = FormItemAttributes;
exports.default = _default;